import { Component, Input } from '@angular/core';

@Component({
  selector: 'immo-ip-placer-immo-task-header',
  templateUrl: './immo-ip-placer-immo-task-header.component.html',
  styleUrls: ['./immo-ip-placer-immo-task-header.component.scss']
})
export class ImmoIPPlacerImmoTaskHeader {
  @Input()
  createdAtDateTime: Date;

  @Input()
  name: string;

  @Input()
  phoneNumber: string;

  @Input()
  mobileNumber: string;

  @Input()
  email: string;
}
